import { api } from "./client";

export function getMe({ signal } = {}) { return api("/api/me", { signal }); }
export function setName(name, { signal } = {}) { return api("/api/me/name", { method: "POST", signal, json: { name } }); }
export function setLanguage(language, { signal } = {}) { return api("/api/me/lang", { method: "POST", signal, json: { lang: language } }); }
export function setTimezone(timezone, source = "manual", { signal } = {}) { return api("/api/me/timezone", { method: "POST", signal, json: { timezone, source } }); }
export function requestEmailChange(email, { signal } = {}) { return api("/api/me/email-change", { method: "POST", signal, json: { email } }); }
